export const APP_KEY = process.env.REACT_APP_APP_KEY || ''
export const APP_ID = process.env.REACT_APP_APP_ID || ''
export const DOMAIN = process.env.REACT_APP_DOMAIN || ''
